<script lang="ts" setup>
import { useEventCommonStore, useEventCommonStoreRef } from '@/stores';
import { onMounted } from 'vue';
import { MenuComp, DateComp, RouterLink } from '@/components';
import HeaderEventTypeAhead from './HeaderEventTypeAhead.vue';
import { isLocalHost, isNextDev } from '@/utilities/utils';

const comStore = useEventCommonStore();
const { Event } = useEventCommonStoreRef();

onMounted(() => {
    comStore.EnsureLoaded(['Event']);
});
</script>
<template>
    <header class="vw-100 fixed-top">
        <div class="container-fluid gap-3">
            <div class="d-flex gap-2 justify-content-between">
                <RouterLink
                    path="/home"
                    class="text-dark"
                >
                    <img
                        v-if="isNextDev()"
                        src="@/assets/img/EQWhite_small-dev.png"
                        style="height: 2rem"
                        class="nav-logo py-2 m-1"
                    />
                    <img
                        v-if="isLocalHost()"
                        src="@/assets/img/EQWhite_small-local.png"
                        style="height: 2rem"
                        class="nav-logo py-2 m-1"
                    />
                    <img
                        v-else
                        src="@/assets/img/EQWhite_small.png"
                        style="height: 2rem"
                        class="nav-logo py-2 m-1"
                    />
                </RouterLink>
                <div class="display-4 my-auto flex-grow-1 text-center">
                    <template v-if="Event != null">
                        <span class="display-3">{{ Event.Name }}</span>
                        <DateComp
                            class="text-muted ms-2 display-6"
                            :value="Event.Date"
                            format="DATE"
                            :monospace="false"
                        />
                    </template>
                </div>

                <div class="flex-shrink-1 px-3 py-1">
                    <div class="d-flex align-items-center p-2 gap-2 position-absolute end-0">
                        <HeaderEventTypeAhead
                            :small="true"
                            :button-only="true"
                        />
                        <MenuComp show-only-on="SMALL" />
                    </div>
                </div>
            </div>
        </div>
    </header>
</template>
